import React from 'react';
import { Smartphone, Tablet, Monitor, Globe, Server } from 'lucide-react';

// A generic type that includes the fields needed to determine device type
export interface DeviceEvent {
  user_agent: string | null;
  metadata: {
    browser?: unknown;
    user_agent?: unknown;
    [key: string]: unknown;
  } | null;
}

export type DeviceType = 'iOS' | 'Android' | 'MacOS' | 'Windows' | 'ChromeOS' | 'Other' | 'Unknown';

export const getDeviceType = (event?: DeviceEvent | null): DeviceType => {
  if (!event) return 'Unknown';
  const userAgent = event.user_agent || (event.metadata?.browser as string) || (event.metadata?.user_agent as string) || null;
  if (!userAgent) return 'Unknown';
  if (/android/i.test(userAgent)) return 'Android';
  if (/iphone|ipad|ipod/i.test(userAgent)) return 'iOS';
  if (/windows/i.test(userAgent)) return 'Windows';
  if (/macintosh|mac os/i.test(userAgent)) return 'MacOS';
  if (/cros/i.test(userAgent)) return 'ChromeOS';
  return 'Other';
};

export const DeviceIcon = ({ deviceType }: { deviceType: DeviceType }) => {
  const iconMap: Record<DeviceType, React.ReactNode> = {
    'iOS': <Tablet className="w-4 h-4" />,
    'Android': <Smartphone className="w-4 h-4" />,
    'MacOS': <Monitor className="w-4 h-4" />,
    'Windows': <Monitor className="w-4 h-4" />,
    'ChromeOS': <Monitor className="w-4 h-4" />,
    'Other': <Globe className="w-4 h-4" />,
    'Unknown': <Server className="w-4 h-4" />,
  };
  const icon = iconMap[deviceType];
  if (!icon) return null;
  return <span title={deviceType}>{icon}</span>;
}; 